Postlogin.Lesson = (function (my) {
    my.Segment = function (segmentData) {
        const me = {};

        // Segment Data
        me.segment_index = segmentData.segment_index;
        me.segment_id = segmentData.segment_id;
        me.user_lesson_segment_id = segmentData.user_lesson_segment_id;
        me.estimated_time = segmentData.estimated_time;
        me.segment_type = segmentData.type_slug;

        if (me.segment_type === 'activity') {
            me.activity_type = segmentData.activity_type_slug;
            me.activity_data = segmentData.activity;
            me.options = segmentData.activity.options;
        }

        me.background_image = null;
        me.scene = null;
        me.help_enabled = false;
        me.play_pause_enabled = true;
        me.replay_enabled = true;
        me.paused = true;
        me.closed_captioner = null;
        me.segment_container = $(`#segment-${me.segment_index}`);
        me.first = segmentData.first;
        me.last = segmentData.last;
        me.started = segmentData.date_started;
        me.completed = segmentData.date_completed;
        me.has_completion_feedback = me.segment_container.find('.completion-feedback').length;
        me.cc_data = null;

        // initialize all of the speech audio files we need
        if (me.segment_type === 'activity') {
            Postlogin.Lesson.preloadSound(me.activity_data.instructions_audio);
            Postlogin.Lesson.preloadSound(me.activity_data.question_audio);
            setTimeout(() => {
                Postlogin.Lesson.preloadSound(me.activity_data.completion_audio);
                $.each(me.options, (optionId, option) => {
                    Postlogin.Lesson.preloadSound(option.answer_audio);
                    Postlogin.Lesson.preloadSound(option.feedback_audio);
                    Postlogin.Lesson.preloadSound(option.hint_audio);
                });
            }, 1000);
        }

        // private data
        let timeoutId = null;

        me.renderSegment = function () {
            return 'This should be overridden by specific segment type!';
        };

        me.renderSegmentContainer = function () {
            return $(`
                <div class="future segment-container segment-type-${me.segment_type}" id="segment-${me.segment_index}" data-segment-id="${me.segment_id}">
                    <div class="segment-wrapper">
                        <div class="aspect-wrapper">
                        </div>
                    </div>
                </div>
            `);
        };

        me.getOptionFeedback = function (optionId) {
            const option = me.options[optionId];

            const { feedback } = option;
            const feedbackTitle = option.feedback_title;
            const feedbackImage = option.feedback_image;
            const optionImage1 = option.answer_image;
            const optionImage2 = option.hint_image;

            if (feedback || feedbackTitle) {
                const feedbackBody = $('<div></div>');
                if (feedbackImage || optionImage1 || optionImage2) {
                    const images = $('<div class="feedback-image-container"></div>');
                    images.append("<div class='wrapper'></div>");

                    let img;
                    if (feedbackImage) {
                        img = $(`<img class="feedback-image" src="${feedbackImage}"></img>`);
                        images.find('.wrapper').append(img);
                    } else {
                        if (optionImage1) {
                            img = $(`<img class="feedback-image" src="${optionImage1}"></img>`);
                            images.find('.wrapper').append(img);
                        }

                        if (optionImage2) {
                            img = $(`<img class="feedback-image" src="${optionImage2}"></img>`);
                            images.find('.wrapper').append(img);
                        }
                    }

                    if (images.find('img').length > 0) {
                        feedbackBody.append(images);
                    }
                }

                feedbackBody.append(feedback);

                return feedbackBody;
            }

            return false;
        };

        me.setCompleted = function () {
            // send ajax request to update completed time for user_lesson_segments
            if (Postlogin.Lesson.getUserLessonId() != null && Postlogin.Lesson.getUserLessonId() > 0) {
                const finishUrl = Slim.Router.urlFor('Lesson.segment.setCompletionTime', {
                    lesson_id: Postlogin.Lesson.getLessonId(),
                    user_lesson_id: Postlogin.Lesson.getUserLessonId(),
                    segment_id: me.segment_id,
                });

                $.get(finishUrl, (data) => {
                    if (typeof data !== 'undefined' && data != null && data !== '') {
                        Postlogin.Lesson.Progress.updatePercentComplete(data);
                    }
                });
            }

            if (typeof Postlogin.Lesson.Progress !== 'undefined') {
                Postlogin.Lesson.Progress.completeSegment(me.segment_index);
            }
            me.completed = true;
        };

        me.advance = function (showNextButton = false) {
            if (!me.last) {
                // if on iOS device, force user to use next button
                // as this gets around the autoplay issue a bit
                const forceManualAdvance = $('body').hasClass('ios');

                if (forceManualAdvance || showNextButton) {
                    Postlogin.Lesson.showNextButton();
                } else {
                    Postlogin.Lesson.nextSegment();
                }
            }
        };

        me.show = function () {
            me.setup();
            $(window).trigger('resize');
        };

        me.setup = function () {
            if (!me.first) {
                $('#previous-segment').addClass('enabled');
            } else {
                $('#previous-segment').removeClass('enabled');
            }

            if (!me.last && me.completed) {
                $('#next-segment').addClass('enabled');
            } else {
                $('#next-segment').removeClass('enabled');
            }

            if (me.help_enabled) {
                $('#beep-9-modal').addClass('enabled');
            } else {
                $('#beep-9-modal').removeClass('enabled');
            }

            if (!me.completed) {
                // send ajax request to update started time...
                if (Postlogin.Lesson.getUserLessonId() != null && Postlogin.Lesson.getUserLessonId() > 0) {
                    const startUrl = Slim.Router.urlFor('Lesson.segment.setStartTime', {
                        lesson_id: Postlogin.Lesson.getLessonId(),
                        user_lesson_id: Postlogin.Lesson.getUserLessonId(),
                        segment_id: me.segment_id,
                    });
                    $.get(startUrl, (data) => {
                        if (typeof data !== 'undefined' && data != null && data !== '') {
                            me.user_lesson_segment_id = parseInt(data);
                        }
                    });
                }
            }

            $('#cc-container').removeClass('shown');

            me.paused = true;
            Postlogin.Lesson.resetPlayPause();

            if (me.play_pause_enabled) {
                $('#segment-controls .segment-pause-play-button').show();
            } else {
                $('#segment-controls .segment-pause-play-button').hide();
            }

            if (me.replay_enabled) {
                $('#segment-controls .segment-replay-button').show();
            } else {
                $('#segment-controls .segment-replay-button').hide();
            }
        };

        me.hide = function () {
            me.breakdown();
        };

        me.breakdown = function () {
            // if we had set up a timeout, clear it
            if (timeoutId != null) {
                clearTimeout(timeoutId);
            }

            me.paused = true;
        };

        me.moveOutLeft = function () {
            $(`#segment-${me.segment_index}`).addClass('past');
        };

        me.moveOutRight = function () {
            $(`#segment-${me.segment_index}`).addClass('future');
        };

        me.moveInLeft = function () {
            $(`#segment-${me.segment_index}`).removeClass('future past');
        };

        me.moveInRight = function () {
            $(`#segment-${me.segment_index}`).removeClass('past future');
        };

        me.setupNextButton = function () {
            // if we had set up a timeout, clear it
            if (timeoutId != null) {
                clearTimeout(timeoutId);
            }

            setTimeout(() => me.setCompleted(), me.estimated_time * 1000);
            timeoutId = setTimeout(() => {
                me.advance();
            }, me.estimated_time * 1000);
        };

        me.isPlayPauseEnabled = function () {
            return me.play_pause_enabled;
        };

        me.toggleCC = function (on = true) {
            if (!on || !me.cc_data) {
                $('#cc-container').removeClass('shown');
            }
        };

        me.togglePlay = function () {
            if (me.paused) {
                me.play();
            } else {
                me.pause();
            }

            return me.paused;
        };

        me.mute = function () {
            //
        };

        me.play = function () {
            return false;
        };

        me.pause = function () {
            return false;
        };

        me.resize = function () {
            return false;
        };

        me.getUserLessonSegmentId = function () {
            return me.user_lesson_segment_id;
        };

        me.speakQuestion = function (wait = 0, callback = null) {
            // speak the instructions
            if (me.activity_data.question_audio) {
                Postlogin.Lesson.playSound(me.activity_data.question_audio, wait, callback);
            } else if (typeof callback === 'function') {
                callback();
            }
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
